import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const GUEST_LIST = `${PRIVATE_ROOT}/apartment/guest-list`
export const ADD_GUEST = `${PRIVATE_ROOT}/apartment/guest-list/add`
export const EDIT_GUEST = `${PRIVATE_ROOT}/apartment/guest-list/:id/edit`
